<style lang="scss">
.editform {
    .vview-formitem {
        min-height: 32px;
    }
}
</style>
<template>
	<vForm class="editform clearfix" v-bind="getFormProps" ref="form">
		<template v-for="(item,index) in formdata">
			<vCol v-if="handleVisible(item)" :key="index" v-bind="getColProps(item)">
				<vFormItem v-bind="getFormItemProps(item)" style="position:relative">
					<vTooltip v-if="item.popper" v-bind="getPopperProps(item)">
                        <Icon class="font-14" type="md-help-circle" style="position: absolute;z-index: 11;right: 5px;top: 10px;" />
						<compRender v-for="data in getFormChildData(item)" :key="data._key" v-bind="data" />
					</vTooltip>
					<compRender v-else v-for="data in getFormChildData(item)" :key="data._key" v-bind="data" />
				</vFormItem>
			</vCol>
		</template>
		<vCol span="24" v-if="$slots.default">
			<slot>
				<!-- <vButton theme="error" class="width-50per" @click="cancel">取消</vButton>
				<vButton theme="primary" class="width-50per" @click="submit">确定</vButton>-->
			</slot>
		</vCol>
	</vForm>
</template>

<script>
import formmixin from "./formmixin";
export default {
	mixins: [formmixin],
	data() {
		return {
			formData: {}
		};
	},
	watch: {
		value: {
			immediate: true,
			deep: true,
			handler(val, old) {
				this.formData = { ...val }
			}
		},
	},
	mounted() {
		window.addEventListener('beforeunload', this.beforeunload, false);
	},
	beforeDestroy() {
		window.removeEventListener('beforeunload', this.beforeunload);
	},
	computed: {
		getFormProps() {
			return {
				labelWidth: 120,
				rules: {
					["*"]: {
						required: true,
						message: this.$t('global.common.fill_required')
					}
				},
				...this.$attrs
			};
		},
	},
	methods: {
		beforeunload(event) {
			const tip = this.$t('global.form.warning');
			event = event || window.event;
			event.returnValue = tip;
			return tip;
		},
		setFormData(key, val) {
			if (this.formData[key] === val) return;
			this.$set(this.formData, key, val);
			this.$emit("input", this.formData);
		},
		getPopperProps(item) {
			return {
				content: item.popper,
				gpu: true,
				class: 'width-100per'
			}
		},
		getFormItemProps(item) {
			const { label, langKey, required = true, key, inline, labelWidth, query, formItem } = item;
			return {
				label: langKey ? this.$t(langKey, { defaultValue: label }) : label,
				inline,
				labelWidth,
				prop: (required && !query) ? key : undefined,
				...formItem
			};
		},
		getFormChildData(item) {
			let {
				tag,
				props,
				key,
				style,
				children,
				options,
				on: onListeners,
				query,
				class: className,
				// attach,
			} = item;
			const hasOptions = Array.isArray(options);
			const on = { ...onListeners };
			Object.keys(on).forEach(key => {
				on[key] = onListeners[key].bind(this);
			});
			if (key && !query) {
				props = Object.assign({ clearable: true }, props, {
					value: this.formData[key]
				});
				// if(attach&& typeof attach==='string'){
				// 	attach=[attach];
				// }
				// if(hasOptions&&Array.isArray(attach)){
				// 	on.input = val =>{
				// 		const len=options.length;
				// 		attach.forEach(attachKey=>{
				// 			this.setFormData(attachKey, '');
				// 			for (let index = 0; index < len; index++) {
				// 				const element = options[index];
				// 				let value=element[attachKey];
				// 				if(value!==undefined){
				// 					this.setFormData(attachKey, value);
				// 					return;
				// 				}
				// 				value=element.attach?element.attach[attachKey]:undefined;
				// 				if(value!==undefined){
				// 					this.setFormData(attachKey, value);
				// 					return;
				// 				}
				// 			}
				// 		})
				// 		this.setFormData(key, val)
				// 	};
				// }else{
				// 	on.input = val => this.setFormData(key, val);
				// }
				on.input = val => this.setFormData(key, val);
			}
			if (query) {
				return (!key && tag) ? [{
					tag,
					style,
					class: className,
					_key: 0,
					on,
					attrs: { ...props },
					children
				}] : [{
					tag: 'div',
					style,
					_key: 0,
					class: className || 'font-bold text-wrap',
					domProps: {
						innerHTML: this.getValueText(item, this.value[key])
					}
				}]
			}
			if (this.isGroupFormChild(tag)) {
				className = className || 'margin-right-15';
				return hasOptions ? options.map((item, index) => {
					let attrs = { ...props, ...item };
					let _on = on;
					if (item.key) {
						attrs.value = this.formData[item.key];
						_on = { ...on, input: val => this.setFormData(item.key, val) };
					}
					return {
						tag,
						style,
						class: className,
						_key: index,
						on: _on,
						attrs,
						children
					}
				}) : [{
					tag,
					style,
					class: className,
					_key: 0,
					on,
					attrs: { ...props },
					children
				}]
            }
            if(tag === 'Select'){
                if (hasOptions) {
                    children = h => {
                        return options.map(item => {
                            if (item === null || typeof item !== 'object') {
                                item = { value: item, label: item }
                            }
                            return h("Option", { attrs: { ...item } });
                        });
                    };
                }
            }else{
                if (hasOptions) {
                    children = h => {
                        return options.map(item => {
                            if (item === null || typeof item !== 'object') {
                                item = { value: item, label: item }
                            }
                            return h("vOption", { attrs: { ...item } });
                        });
                    };
                }
            }
			return [{
				tag: tag || "vInput",
				style,
				class: className,
				_key: key,
				on,
				attrs: props,
				children
			}];
		},
		async validate() {
			const bool = await this.$refs.form.validate();
			if (!bool) {
				this.$VMessage.warning(this.$t('global.common.fill_required'));
				return Promise.reject(false);
			}
			return true;
		},
		resetValidate() {
			this.$refs.form.resetValidate();
		}
	}
};
</script>